import React from "react";

const Loader = () => {
  return (
    <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-10 z-50 left-0 w-full">
      <div className="w-14 h-14 border-4 border-transparent border-t-primaryDark border-l-blue-500 rounded-full animate-spin"></div>
    </div>
  );
};

export default Loader;
